type WorkloadProjectPeriod = {
  from: string;
  to: string;
  load: number;
};

const workloadProjectPeriod: WorkloadProjectPeriod = {
  from: "",
  to: "",
  load: 0,
};

export type { WorkloadProjectPeriod };

export { workloadProjectPeriod };
